import { createSelector } from 'reselect';

export const getControllerArchitecture = (currentController, ezlo) => {
    const currentControllerData = ezlo.data[currentController];
    if (currentControllerData && currentControllerData.info?.architecture) {
        return currentControllerData.info.architecture;
    }

    return null;
};
export const hubTimeZoneSelector = ({ ezlo }) => ezlo.data[ezlo.serial].location?.timezone;
export const serialSelector = ({ ezlo }) => ezlo.serial;
const backupsViewSelector = ({ backups }) => backups.view;
const isBackupSupportedSelector = ({ backups }) => backups.isBackupSupported;
export const backupsSelector = ({ backups }) => backups.backups;
const createBackupProgressValueSelector = ({ backups }) => backups.createBackupProgressValue;
const restoreBackupStepSelector = ({ backups }) => backups.restoreBackupStep;
const selectedBackupSelector = ({ backups }) => backups.selectedBackup;
const restoreBackupProgressValueSelector = ({ backups }) => backups.restoreBackupProgressValue;
const isBackupsLoadingSelector = ({ backups }) => backups.isBackupsLoading;
const createBackupStepSelector = ({ backups }) => backups.createBackupStep;
const isNewBackupInProgressSelector = ({ backups }) => backups.isNewBackupInProgress;
const isRestoreBackupInProgressSelector = ({ backups }) => backups.isRestoreBackupInProgress;

export const structuredBackupsSelector = createSelector(
    backupsViewSelector,
    createBackupProgressValueSelector,
    restoreBackupStepSelector,
    selectedBackupSelector,
    restoreBackupProgressValueSelector,
    isBackupsLoadingSelector,
    createBackupStepSelector,
    isNewBackupInProgressSelector,
    isRestoreBackupInProgressSelector,
    isBackupSupportedSelector,
    (
        view,
        createBackupProgressValue,
        restoreBackupStep,
        selectedBackup,
        restoreBackupProgressValue,
        isBackupsLoading,
        createBackupStep,
        isNewBackupInProgress,
        isRestoreBackupInProgress,
        isBackupSupported,
    ) => {
        return {
            view,
            createBackupProgressValue,
            restoreBackupStep,
            selectedBackup,
            restoreBackupProgressValue,
            isBackupsLoading,
            createBackupStep,
            isNewBackupInProgress,
            isRestoreBackupInProgress,
            isBackupSupported,
        };
    },
);

export const isCurrentControllerConnectedSelector = ({ ezlo, ezlos }) => {
    const controllers = ezlos?.items;
    const controllerInfo = controllers.find(({ serial }) => serial === ezlo.serial);

    return controllerInfo?.connected || false;
};
